"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeProps = exports.Components = void 0;
var tslib_1 = require("tslib");
var PickerButton_1 = tslib_1.__importDefault(require("../PickerButton"));
var PickerTag_1 = tslib_1.__importDefault(require("../PickerTag"));
var generateRangePicker_1 = tslib_1.__importDefault(require("./generateRangePicker"));
var generateSinglePicker_1 = tslib_1.__importDefault(require("./generateSinglePicker"));
exports.Components = { button: PickerButton_1.default, rangeItem: PickerTag_1.default };
function toArray(list) {
    if (!list) {
        return [];
    }
    return Array.isArray(list) ? list : [list];
}
function getTimeProps(props) {
    var format = props.format, picker = props.picker, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours;
    var firstFormat = toArray(format)[0];
    var showTimeObj = tslib_1.__assign({}, props);
    if (firstFormat && typeof firstFormat === 'string') {
        if (!firstFormat.includes('s') && showSecond === undefined) {
            showTimeObj.showSecond = false;
        }
        if (!firstFormat.includes('m') && showMinute === undefined) {
            showTimeObj.showMinute = false;
        }
        if (!firstFormat.includes('H') && !firstFormat.includes('h') && showHour === undefined) {
            showTimeObj.showHour = false;
        }
        if ((firstFormat.includes('a') || firstFormat.includes('A')) && use12Hours === undefined) {
            showTimeObj.use12Hours = true;
        }
    }
    if (picker === 'time') {
        return showTimeObj;
    }
    if (typeof firstFormat === 'function') {
        // format of showTime should use default when format is custom format function
        delete showTimeObj.format;
    }
    return {
        showTime: showTimeObj,
    };
}
exports.getTimeProps = getTimeProps;
function generatePicker(generateConfig) {
    // =========================== Picker ===========================
    var _a = (0, generateSinglePicker_1.default)(generateConfig), DatePicker = _a.DatePicker, WeekPicker = _a.WeekPicker, MonthPicker = _a.MonthPicker, YearPicker = _a.YearPicker, TimePicker = _a.TimePicker, QuarterPicker = _a.QuarterPicker;
    // ======================== Range Picker ========================
    var RangePicker = (0, generateRangePicker_1.default)(generateConfig);
    var MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
}
exports.default = generatePicker;
//# sourceMappingURL=index.js.map